export const preloadImage = (imageList: string[]) => {
  imageList.forEach((image) => {
    const newImage = new Image();
    newImage.src = image;
    (window as { [key: string]: any })[image] = newImage;
  });
};
